const comments = [
  {
    name: '漫画迷小王',
    text: '终于找到一个专门做漫画全集的网站了！下拉式阅读太舒服了，不用一话一话点翻页，一口气看完《鬼灭之刃》全集，爽到飞起。',
    time: '3天前',
    avatar: 'ri-user-smile-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    name: '韩漫爱好者',
    text: '亲亲漫画网的韩漫全集很全，之前追的几部完结韩漫这里都有收录，而且画质清晰，加载也快，安利给身边的漫友了！',
    time: '5天前',
    avatar: 'ri-user-heart-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    name: '深夜追漫人',
    text: '日漫完结大全这块做得真好，好多经典老番的全集都能找到。下拉式阅读简直是熬夜追漫神器，根本停不下来。',
    time: '1周前',
    avatar: 'ri-moon-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    name: '校园漫死忠',
    text: '漫画全集免费这点真的良心。之前在其他平台看一半要付费，这里全免费而且全集一次看完，校园恋爱漫一本满足。',
    time: '1周前',
    avatar: 'ri-emotion-happy-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    name: '漫画收藏家',
    text: '5000多部完结作品，漫画大全名副其实！分类清楚，榜单也很实用，每天来看看有什么好看的完结漫画已经成为习惯了。',
    time: '2周前',
    avatar: 'ri-star-line',
    color: 'bg-accent-100 text-accent-600',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          漫友说
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          来自漫画爱好者的真实声音，看看大家怎么说
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200 p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className={`w-10 h-10 flex items-center justify-center rounded-full ${comment.color}`}>
                  <i className={`${comment.avatar} text-lg`}></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}